import React from "react";

import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";

import { useTheme } from "@material-ui/core/styles"; //for responsive
import useMediaQuery from "@material-ui/core/useMediaQuery";

import { useProjectStyles } from "./ProjectStyles";

import { Tooltip } from "@material-ui/core";
import { IconButton } from "@material-ui/core";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";

import kaura from "../images/projects/kaura.png";
import { Box } from "@material-ui/core";
import { MYCOLORS } from "../../mypallette";

import CodeIcon from "@material-ui/icons/Code";

import ProjectCardKauraTooltips from "./ProjectCardKauraTooltips";

const ProjectCardKaura = () => {
  //access to theme
  const theme = useTheme();
  //matchSmall is true if window is sm or less(down)
  const matchLarge = useMediaQuery(theme.breakpoints.up("lg"));

  const classes = useProjectStyles({ color: "#5D468F" }); //color of background, make it similar to the image color

  return (
    <CardActionArea className={classes.actionArea} disableRipple>
      <Card className={matchLarge ? classes.cardLarge : classes.card} elevation={4}>
        <CardMedia className={classes.cardMedia} component='img' image={kaura} />
        <CardContent className={classes.content}>
          <Box style={{ flexGrow: 1, display: "flex", alignItems: "center", flexWrap: "wrap" }}>
            <Typography className={classes.title} variant={"h2"}>
              Kaura
            </Typography>

            <Tooltip placement='top' title='Open Project Site in New Window'>
              <IconButton
                size='medium'
                href='https://kaura.app'
                target='_blank'
                style={{ color: MYCOLORS.dhighlight }}
                rel='noreferrer'
              >
                <OpenInNewIcon />
              </IconButton>
            </Tooltip>
          </Box>

          <Typography className={classes.subtitle}>
            Kaura helps dev teams monitor and forecast when they can complete their Jira backlog items. 
            <Tooltip placement='bottom' title={<ProjectCardKauraTooltips />}>
              <CodeIcon style={{ color: MYCOLORS.dhighlight, verticalAlign: "middle" }} />
            </Tooltip>
          </Typography>
        </CardContent>
      </Card>
    </CardActionArea>
  );
};

export default ProjectCardKaura;
